import {ACTION_TYPES, createAction} from "../actions";
import {call, put, takeEvery} from 'redux-saga/effects'
import {delay} from "redux-saga";
import {requestGeometryNodes} from "../../http/requestGeometries";
import {Entitiesview, EntitiesviewAdmin} from "../../../types";

export function* loadGeometrySaga () {
    yield takeEvery(ACTION_TYPES.FETCH_GEOMETRY_LAYER as any, loadGeometryData as any);
}

export function* loadGeometryData () {
    yield delay(50);
    try {
        yield put(createAction(ACTION_TYPES.FETCH_LAYERS, {}));

        const data = yield call(requestGeometryNodes);

        // since the request is ordered by type, we can do this
        while (data.length > 0) {
            const nodeList: Entitiesview|EntitiesviewAdmin[] = [];
            const type = data[data.length - 1].type;
            // console.log('GEO TYPE', data[data.length - 1].geoType, data[data.length - 1]);
            const geoType = data[data.length - 1].geoType.toLowerCase(); // replace w better func
            while (data.length > 0 && type === data[data.length - 1].type) {
                nodeList.push(data.pop());
            }
            yield put(createAction(ACTION_TYPES.FETCH_GEOMETRY_LAYER_SUCCESS, {
                data: nodeList, layerType: type, geoType
            }));
            yield delay(50)
            yield put(createAction(ACTION_TYPES.FETCH_ALL_GEOMETRY_LAYER_SUCCESS, {
                layerType: type
            }));
        }

        yield put(createAction(ACTION_TYPES.FETCH_ALL_GEOMETRY_LAYER_SUCCESS, {}));

    } catch (error) {
        yield put(createAction(ACTION_TYPES.FETCH_GEOMETRY_LAYER_ERROR, {error}));
    }
}
